import { Injectable, signal } from '@angular/core';
import { environment } from '@environments/environment';
import { ApiCacheService } from '@shared/services/cache-service/api-cache.service';
import { SignalsService } from '@shared/services/signals/signals.service';
import { SearchForm } from './model/search-form';
import { EMPTY, map, Observable } from 'rxjs';
import { RequestState } from '@shared/models/request-state';
import { SearchResult } from './model/search-result';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DateTime } from 'luxon';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { StationList } from './model/stations-list';

@Injectable({
  providedIn: 'root'
})
export class SearchService {


  private readonly _apiUrl = `${environment.apiUrl}/search`
  ref: DynamicDialogRef | null = null;

  cacheId: number = 0;
  searchResultsPage$ = signal<number>(0);

  constructor(
    public signalService: SignalsService,
    private dialogService: DialogService,
    private cacheService: ApiCacheService,
    private http: HttpClient,
    private route: ActivatedRoute
  ) { }

  makeSearchRequest(formBody: SearchForm, empNum: string): Observable<RequestState<SearchResult>> {

    const cacheId = this.addCacheId(); 
    const url = `${this._apiUrl}/${empNum}`;
    return this.cacheService.request<SearchResult>(
      cacheId,
      url,
      'items',
      formBody
    );
  }

  fetchAiportList(): Observable<any> {
    return this.http.get('./assets/data/stations.json').pipe(
            map((versionData) => {
              if(!versionData) {
                return EMPTY;
              }
              return versionData;
            })
          )
  }

  

  clearOldSearchResultsCache(): void {
    const keys = Object.keys(localStorage);

    for (const key of keys) {
      if (key.includes('searchResults')) {
        localStorage.removeItem(key);
    }
  }
}

  private addCacheId(): string {
    const cacheIdStamp = this.cacheId++;
    return `searchResults-${cacheIdStamp}`;
  }

  openDialog(component: any): void {
    const form = this.route.snapshot.queryParamMap.get('form');
    this.ref = this.dialogService.open(component, {
      data: {form},
      header: 'Search Not Found',
      width: '50vw',
      modal: true,
      dismissableMask: true,
      breakpoints: {
        '500px': '50vw',
      }
    });
  }

  closeDialog(): void {
    if (this.ref) {
      this.ref.close();
    }
  }
}
